
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Toca «Abrir en el navegador…»`,
's182ab2d6c997515f': `Añádelo a tu pantalla de inicio para una experiencia amplia y acceso fácil.`,
's224cbcec014ef6b5': `Presionar Compartir en la barra de direcciones`,
's233af3b7eb5e0364': `Añadir al Carrito`,
's37a9e8aec5713460': `Más`,
's4c3161035f3a1413': `Presiona Menú`,
's4e1e10a6ca408245': `Toca "Añadir a pantalla de inicio"`,
's6196153c4b0c1ea0': `Instalar`,
's633502f7cff4f847': `Abre el menú de tu navegador`,
's681e399d63311fba': `Mostrar galería`,
's6d14a4f70ba4e3cf': `Presiona Menú si no hay icono de Compartir`,
's922329d6f6213590': `Añadir al Dock`,
's9c63a79ffcc2a3a3': `Presiona "Añadir a pantalla de inicio"`,
'sa2d71bfd9525168d': `Presiona "Añadir al Dock"`,
'sa5ef80b4bb9b39f8': `Menos`,
'sb527eca1c1d7e7be': `Abre el menú del navegador integrado`,
'sba52286c21552a4e': `Instálalo en tu dispositivo para una experiencia amplia y acceso fácil.`,
'sc16e00a7a8b2fde2': `Atrás`,
'scdaf4bbff76674c8': `Añadir a pantalla de inicio`,
'sd18a5b85f599ff3c': `Abre el enlace copiado en Safari`,
'se72fc3a84f9b51c3': `Toca para copiar el enlace`,
'se740f75b95a51807': `Añádelo a tu Dock para una experiencia amplia y acceso fácil.`,
'sfa6c42cdf48d93d2': `Pero este navegador no admite esta función. Abre el enlace en un navegador externo para continuar.`,
'sfb78526365796a41': `Presiona "Ver más" en el menú Compartir`,
'sfea652f6580ff086': `Este sitio tiene funcionalidad de aplicación.`,
    };
  